import moment from 'moment'
import settings from '@/services/settings'

export function formatDate (date) {
  return moment(date).format(settings.dateFormat)
}

export function formatTime (time) {
  let hour = parseInt(time)
  let minutes = (time % hour) * 60
  if (minutes === 0) {
    minutes = '00'
  }
  return hour + ':' + minutes
}

export function formatDateTime (datetime) {
  return moment(datetime).format(settings.dateTimeFormat)
}

export function formatAge (date) {
  return moment().diff(date, 'years')
}



// WEBPACK FOOTER //
// ./src/filters/index.js